/* import __COLOCATED_TEMPLATE__ from './join-referral-program-container.hbs'; */
import AuthenticatorService from 'codecrafters-frontend/services/authenticator';
import Component from '@glimmer/component';
import Store from '@ember-data/store';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import amazonImage from '/assets/images/company-logos/amazon-company-logo.svg';
import appleImage from '/assets/images/company-logos/apple-company-logo.svg';
import coinbaseImage from '/assets/images/company-logos/coinbase-company-logo.svg';
import figmaImage from '/assets/images/company-logos/figma-company-logo.svg';
import googleImage from '/assets/images/company-logos/google-company-logo.svg';
import harvardImage from '/assets/images/company-logos/harvard-logo.svg';
import hashiCorpImage from '/assets/images/company-logos/hashicorp-company-logo.svg';
import mitImage from '/assets/images/company-logos/mit-logo.svg';
import slackImage from '/assets/images/company-logos/slack-company-logo.svg';
import stripeImage from '/assets/images/company-logos/stripe-company-logo.svg';

export default class JoinReferralProgramContainer extends Component {
  @service declare authenticator: AuthenticatorService;
  @service declare store: Store;

  @tracked isCreatingReferralLink = false;

  get companies() {
    return [
      {
        name: 'Google',
        url: googleImage,
      },
      {
        name: 'Slack',
        url: slackImage,
      },
      {
        name: 'Amazon',
        url: amazonImage,
      },
      {
        name: 'Figma',
        url: figmaImage,
      },
      {
        name: 'Stripe',
        url: stripeImage,
      },
      {
        name: 'Apple',
        url: appleImage,
      },
      {
        name: 'Coinbase',
        url: coinbaseImage,
      },
      {
        name: 'HashiCorp',
        url: hashiCorpImage,
      },
      {
        name: 'Harvard',
        url: harvardImage,
      },
      {
        name: 'MIT',
        url: mitImage,
      },
    ];
  }

  get currentUser() {
    return this.authenticator.currentUser;
  }

  @action
  async handleGetStartedButtonClick() {
    const referralLink = this.store.createRecord('referral-link', {
      user: this.currentUser,
    });

    this.isCreatingReferralLink = true;
    await referralLink.save();
    this.isCreatingReferralLink = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ReferralsPage::JoinReferralProgramContainer': typeof JoinReferralProgramContainer;
  }
}
